<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-tabs content-class="mt-3">
                <b-tab
                  title="Niño"
                  v-if="
                    DiagnosticData.denticion == 1 ||
                    DiagnosticData.denticion == 3
                  "
                >
                  <br />
                  <!-- plan de ortodoncia -->
                  <span>
                    <!-- Nino -->
                    <span
                      v-if="
                        DiagnosticData.denticion == 1 ||
                        DiagnosticData.denticion == 3
                      "
                    >
                      <h3>Plan de Ortopedia Niño</h3>
                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX I</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX II</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX III</b-th>
                          </b-tr>
                        </b-thead>

                        <tr
                          v-for="(item, index) in titlesOrtodonciaNino"
                          :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                              type="number"
                              v-model="
                                ortodonciaNino['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                              min="1"
                              max="20"
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                              v-model="
                                ortodonciaNino['tratamientos1'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                              :options="optionsArcoBoca"
                              :disabled="
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 134 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                            ></b-form-select>
                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 134
                              "
                              label="nombre"
                              :options="dataTreatmentsOrtoOdonto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNino['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <p
                              v-if="
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                              class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                          <!-- Segunda columna de trts -->
                          <td>
                            <b-form-input
                              type="number"
                              v-model="
                                ortodonciaNino['tratamientos2'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                              v-model="
                                ortodonciaNino['tratamientos2'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                              :options="optionsArcoBoca"
                              :disabled="
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 134 ||
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                            ></b-form-select>
                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 134
                              "
                              label="nombre"
                              :options="dataTreatmentsOrtoOdonto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNino['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <p
                              v-if="
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                              class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                          <!-- Tercer columna de trts -->
                          <td>
                            <b-form-input
                              type="number"
                              v-model="
                                ortodonciaNino['tratamientos3'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                              v-model="
                                ortodonciaNino['tratamientos3'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                              :options="optionsArcoBoca"
                              :disabled="
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 134 ||
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                            ></b-form-select>
                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 131 ||
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 132 ||
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 134
                              "
                              label="nombre"
                              :options="dataTreatmentsOrtoOdonto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNino['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- Otra opcion -->
                            <p
                              v-if="
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 133 ||
                                ortodonciaNino['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 135
                              "
                              class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                        </tr>
                      </b-table-simple>

                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX I</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX II</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX III</b-th>
                          </b-tr>
                        </b-thead>
                        <tr
                          v-for="(item, index) in titlesOrtodonciaNinoDientes"
                          :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                              disabled
                              type="number"
                              v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                              v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'lstDientes'
                                ]
                              "
                              taggable
                              multiple
                              :options="dientesNinoArray"
                              label="numeroDiente"
                              :reduce="(variable) => variable.idDiente"
                              @input="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaNinoDientes['tratamientos1'][index][
                                    'lstDientes'
                                  ].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 136
                              "
                              label="nombre"
                              :options="dataTreatmentsExtracciones"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 137
                              "
                              label="nombre"
                              :options="dataTreatmentsTopesResina"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 138
                              "
                              label="nombre"
                              :options="dataTreatmentsTraccionCaninos"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                          <!-- Segunda columna de trts -->
                          <td>
                            <b-form-input
                              disabled
                              type="number"
                              v-model="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                              v-model="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'lstDientes'
                                ]
                              "
                              taggable
                              multiple
                              :options="dientesNinoArray"
                              label="numeroDiente"
                              :reduce="(variable) => variable.idDiente"
                              @input="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaNinoDientes['tratamientos2'][index][
                                    'lstDientes'
                                  ].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 136
                              "
                              label="nombre"
                              :options="dataTreatmentsExtracciones"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 137
                              "
                              label="nombre"
                              :options="dataTreatmentsTopesResina"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 138
                              "
                              label="nombre"
                              :options="dataTreatmentsTraccionCaninos"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                          <!-- Tercer columna de trts -->
                          <td>
                            <b-form-input
                              disabled
                              type="number"
                              v-model="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                              v-model="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'lstDientes'
                                ]
                              "
                              taggable
                              multiple
                              :options="dientesNinoArray"
                              label="numeroDiente"
                              :reduce="(variable) => variable.idDiente"
                              @input="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaNinoDientes['tratamientos3'][index][
                                    'lstDientes'
                                  ].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 136
                              "
                              label="nombre"
                              :options="dataTreatmentsExtracciones"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 137
                              "
                              label="nombre"
                              :options="dataTreatmentsTopesResina"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 138
                              "
                              label="nombre"
                              :options="dataTreatmentsTraccionCaninos"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaNinoDientes['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                        </tr>
                      </b-table-simple>
                    </span>
                    <!-- Nino -->
                  </span>
                  <br />
                  <br />
                </b-tab>
                <b-tab
                  title="Adulto"
                  v-if="
                    DiagnosticData.denticion == 2 ||
                    DiagnosticData.denticion == 3
                  "
                >
                  <br />
                  <!-- plan de ortodoncia -->
                  <span>
                    <!-- Adulto -->
                    <span
                      v-if="
                        DiagnosticData.denticion == 2 ||
                        DiagnosticData.denticion == 3
                      "
                    >
                      <h3>Plan de Ortodoncia Adulto</h3>
                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX I</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX II</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>ARCO / BOCA</b-th>
                            <b-th>TX III</b-th>
                          </b-tr>
                        </b-thead>
                        <tr
                          v-for="(item, index) in titlesOrtodonciaAdulto"
                          :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                              type="number"
                              v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                              min="1"
                              max="20"
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                              :disabled="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 121 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                              v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                              :options="optionsArcoBoca"
                            ></b-form-select>
                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 121
                              "
                              label="nombre"
                              :options="dataTreatmentsOrtoOdonto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 109 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 110 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 171 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 172 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 173
                              "
                              label="nombre"
                              :options="dataTreatmentsOrto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>

                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 111 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 112
                              "
                              label="nombre"
                              :options="dataTreatmentsRetenedores"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <p
                              v-if="
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                              class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                          <!-- Segunda columna de trts -->
                          <td>
                            <b-form-input
                              type="number"
                              v-model="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                              v-model="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                              :options="optionsArcoBoca"
                              :disabled="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 121 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                            ></b-form-select>
                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 121
                              "
                              label="nombre"
                              :options="dataTreatmentsOrtoOdonto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 109 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 110 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 171 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 172 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 173
                              "
                              label="nombre"
                              :options="dataTreatmentsOrto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>

                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 111 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 112
                              "
                              label="nombre"
                              :options="dataTreatmentsRetenedores"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>

                            <!-- Otra opcion -->
                            <p
                              v-if="
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                              class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                          <!-- Tercer columna de trts -->
                          <td>
                            <b-form-input
                              type="number"
                              v-model="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <b-form-select
                              v-model="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idDienteArcoBoca'
                                ]
                              "
                              :options="optionsArcoBoca"
                              :disabled="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 121 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                            ></b-form-select>
                          </td>
                          <td>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 118 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 113 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 121
                              "
                              label="nombre"
                              :options="dataTreatmentsOrtoOdonto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 109 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 110 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 171 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 172 ||
                                ortodonciaAdulto['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 173
                              "
                              label="nombre"
                              :options="dataTreatmentsOrto"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>

                            <!-- Otra opcion -->
                            <v-select
                              v-if="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 111 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 112
                              "
                              label="nombre"
                              :options="dataTreatmentsRetenedores"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>

                            <!-- Otra opcion -->
                            <p
                              v-if="
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 120 ||
                                ortodonciaAdulto['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 122
                              "
                              class="txtCitaAjuste"
                            >
                              CITA DE AJUSTE APARATO DE ORTOPEDIA
                            </p>
                          </td>
                        </tr>
                      </b-table-simple>

                      <b-table-simple>
                        <b-thead>
                          <b-tr class="columnas">
                            <b-th>PLAN DE ORTODONCIA</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX I</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX II</b-th>
                            <b-th>CANTIDAD</b-th>
                            <b-th>OD</b-th>
                            <b-th>TX III</b-th>
                          </b-tr>
                        </b-thead>
                        <tr
                          v-for="(item, index) in titlesOrtodonciaAdultoDientes"
                          :key="index"
                        >
                          <td class="columnas colorSubtitle">{{ item }}</td>
                          <td>
                            <b-form-input
                              disabled
                              type="number"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                              v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'lstDientes'
                                ]
                              "
                              taggable
                              multiple
                              :options="dientesAdultoArray"
                              label="numeroDiente"
                              :reduce="(variable) => variable.idDiente"
                              @input="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaAdultoDientes['tratamientos1'][
                                    index
                                  ]['lstDientes'].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 128
                              "
                              label="nombre"
                              :options="dataTreatmentsExtracciones"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 115
                              "
                              label="nombre"
                              :options="dataTreatmentsMiniImplantes"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 116
                              "
                              label="nombre"
                              :options="dataTreatmentsTopesResina"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idPadecimento'
                                ] == 117
                              "
                              label="nombre"
                              :options="dataTreatmentsTraccionCaninos"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos1'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                          <!-- Segunda columna de trts -->
                          <td>
                            <b-form-input
                              disabled
                              type="number"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                              v-model="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'lstDientes'
                                ]
                              "
                              taggable
                              multiple
                              :options="dientesAdultoArray"
                              label="numeroDiente"
                              :reduce="(variable) => variable.idDiente"
                              @input="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaAdultoDientes['tratamientos2'][
                                    index
                                  ]['lstDientes'].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 128
                              "
                              label="nombre"
                              :options="dataTreatmentsExtracciones"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 115
                              "
                              label="nombre"
                              :options="dataTreatmentsMiniImplantes"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 116
                              "
                              label="nombre"
                              :options="dataTreatmentsTopesResina"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idPadecimento'
                                ] == 117
                              "
                              label="nombre"
                              :options="dataTreatmentsTraccionCaninos"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos2'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                          <!-- Tercer columna de trts -->
                          <td>
                            <b-form-input
                              disabled
                              type="number"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'cantidad'
                                ]
                              "
                            ></b-form-input>
                          </td>
                          <td>
                            <v-select
                              v-model="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'lstDientes'
                                ]
                              "
                              taggable
                              multiple
                              :options="dientesAdultoArray"
                              label="numeroDiente"
                              :reduce="(variable) => variable.idDiente"
                              @input="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'cantidad'
                                ] =
                                  ortodonciaAdultoDientes['tratamientos3'][
                                    index
                                  ]['lstDientes'].length
                              "
                            />
                          </td>
                          <td>
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 128
                              "
                              label="nombre"
                              :options="dataTreatmentsExtracciones"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 115
                              "
                              label="nombre"
                              :options="dataTreatmentsMiniImplantes"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 116
                              "
                              label="nombre"
                              :options="dataTreatmentsTopesResina"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                            <v-select
                              v-if="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idPadecimento'
                                ] == 117
                              "
                              label="nombre"
                              :options="dataTreatmentsTraccionCaninos"
                              :reduce="(treatment) => treatment.idTratamiento"
                              v-model="
                                ortodonciaAdultoDientes['tratamientos3'][index][
                                  'idTratamiento'
                                ]
                              "
                            ></v-select>
                            <!-- otro -->
                          </td>
                        </tr>
                      </b-table-simple>
                    </span>
                  </span>

                  <br />
                  <br />
                </b-tab>
              </b-tabs>
              
              
              <br/><br/><br/>
              
               <b-button
              class="btnSave"
              @click="sendData()"
              :disabled="banderaBtn == true "
              v-if="!mostrarGuardarReplica"
              >GUARDAR ORTODONCIA </b-button
            >
              
              <br/><br/>
              
              
  </div>
</template>

<script>
export default {
  name: "OrtodonciaOpcionesComponente",
  props: {
    data: Object,
    resource: Object,
    idPaciente: Number,
  },
   data: () =>   ({
     version: process.env.VUE_APP_ENV_VERSION,
     debug: false,
     mostrarGuardarReplica: false,
    dientesNino: [],
     DiagnosticData: {
      denticion: null,
    }, 
    dientesAdulto: [],
    titlesOrtodonciaAdulto: [
      "ESTUDIOS",
      "BRACKETS/ALINEADORES",
      "CITAS",
      "CITAS",
      "CITAS",
      "CITAS",
      "RET SUP",
      "RET INF",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
    ],
    ortodonciaAdulto: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    titlesOrtodonciaAdultoDientes: [
      "EXTRACCIONES",
      "MINI IMPLANTES",
      "TOPES DE RESINA",
      "TRACCIÓN DE CANINOS",
    ],
    ortodonciaAdultoDientes: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    titlesOrtodonciaNino: [
      "ESTUDIOS",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
      "APARATO ORTOPEDIA",
      "CITA DE AJUSTE APARATO DE ORTOPEDIA",
    ],
    ortodonciaNino: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    titlesOrtodonciaNinoDientes: [
      "EXTRACCIONES",
      "TOPES DE RESINA",
      "TRACCIÓN DE CANINOS",
    ],
    ortodonciaNinoDientes: {
      tratamientos1: [],
      tratamientos2: [],
      tratamientos3: [],
    },
    optionsArcoBoca: [
      {
        value: 0,
        text: "Selecciona una opción",
      },
      {
        value: 57,
        text: "Superior",
      },
      {
        value: 58,
        text: "Inferior",
      },
      {
        value: 59,
        text: "Boca Completa",
      },
    ],
    dataTreatmentsOrtoOdonto: [],
    dataTreatmentsOrto: [],
    // POR ID
    dataTreatmentsRetenedores: [],
    dataTreatmentsCitaAjuste: [],
    dataTreatmentsExtracciones: [],
    dataTreatmentsMiniImplantes: [],
    dataTreatmentsTopesResina: [],
    dataTreatmentsTraccionCaninos: [],
    dientesAdultoArray: [],
    dientesNinoArray: [],
    idClinica: null,
    banderaBtn: false,
  }),
  beforeMount() {
    this.ptiId = parseInt(this.$route.params.idPti, 10); 
    this.getDientes("dientesAdulto");
    this.getDientes("dientesNino");
    // ! GET ORTODONCIA
    this.getOrtodoncia();
  },
  
  mounted() {
    this.createArray("tratamientos1");
    this.createArray("tratamientos2");
    this.createArray("tratamientos3");
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  
  methods: {
    
    
    
    createArray(treatment) {
      this.ortodonciaAdulto[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 59,
          idPadecimento: 118,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 109,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 110,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 171,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 172,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 173,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 111,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 112,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 113,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 120,
          idTratamiento: 49,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 121,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 122,
          idTratamiento: 49,
          lstDientes: [],
        },
      ];

      this.ortodonciaAdultoDientes[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 128,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 115,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 116,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 117,
          idTratamiento: 0,
          lstDientes: [],
        },
      ];

      this.ortodonciaNino[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 59,
          idPadecimento: 131,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 132,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 57,
          idPadecimento: 133,
          idTratamiento: 49,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 134,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 58,
          idPadecimento: 135,
          idTratamiento: 49,
          lstDientes: [],
        },
      ];

      this.ortodonciaNinoDientes[treatment] = [
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 136,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 137,
          idTratamiento: 0,
          lstDientes: [],
        },
        {
          cantidad: 0,
          idDienteArcoBoca: 0,
          idPadecimento: 138,
          idTratamiento: 0,
          lstDientes: [],
        },
      ];
    },
    getOrtodoncia() {
      const params = {
        idPti: this.ptiId, 
        perfilPaciente: false
      }
      this.$http
        .post(
          this.$api +
            "ptipresuntivo/obtener/planes/ortodoncia", params)
        .then((response) => {
          this.observaciones = response.data.data.observaciones;
          response.data.data.tratamientos1.forEach((element) => {
            this.ortodonciaAdulto.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaAdultoDientes.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA ADULTO
            this.ortodonciaNino.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaNinoDientes.tratamientos1.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
          });
          //el dos

          response.data.data.tratamientos2.forEach((element) => {
            this.ortodonciaAdulto.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaAdultoDientes.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA ADULTO
            this.ortodonciaNino.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaNinoDientes.tratamientos2.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
          });
          // el tres
          response.data.data.tratamientos3.forEach((element) => {
            // ! TERMINA Nino
            this.ortodonciaAdulto.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaAdultoDientes.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA ADULTO
            this.ortodonciaNino.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            this.ortodonciaNinoDientes.tratamientos3.forEach((elementUno) => {
              if (element.idPadecimento == elementUno.idPadecimento) {
                elementUno.cantidad = element.cantidad;
                elementUno.idTratamiento = element.idTratamiento;
                elementUno.idDienteArcoBoca = element.idDienteArcoBoca;
                elementUno.lstDientes = element.lstDientes;
              }
            });
            // ! TERMINA Nino
          });

          this.$forceUpdate();
          
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al obtener la seccion de ortodoncia",
          });
          console.error(error);
        });
    }, 
    getTreatmentsIds(array) {
      const params = {
        idClinica: this.idClinica,
        lstIdsTratatamiento: array
      }
      this.$http
        .put(
          this.$api +
            "ptipresuntivo/obtener/catalogo/tratamientos/id",
          params
        )
        .then((response) => {
            
          // if (
          //   array.includes(6) && //guarda oclusal
          //   array.includes(120) && //retenedor placa circunferencial
          //   array.includes(127) && //retenedor placa hawley 
          //   array.includes(618) //retenedor fijo
          // ) {
          //   //#RET SUP
          //   //#RET INF
          //   this.dataTreatmentsRetenedores = response.data.data.filter(
          //     function (item) {
          //       return item.nombre != "";
          //     }
          //   );
          // } 
          
          
          
          if (
            array.includes(33)  && //mantenedores de espacios
            array.includes(35) && //Arco lingual
            array.includes(629) && //Trainer for kids 
            array.includes(294) && // Arco extraoral
            array.includes(1988) && //Aparato Miofunciona
            array.includes(1989) && //Esqueleto de Sujeción de Máscara Facial con Hyrax
            array.includes(1990) && //Expansores 
            array.includes(1991)  // Banda Ansa 
          ) {
            //#RET SUP
            //#RET INF
            this.dataTreatmentsRetenedores = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
          } else if (array.includes(49)) {//cita de ajuste aparato de ortopedia
          //#CITA DE AJUSTE APARATO DE ORTOPEDIA
            this.dataTreatmentsCitaAjuste = response.data.data.filter(function (
              item
            ) {
              return item.nombre != "";
            });
          } else if (
            array.includes(9) && //extraccion sencilla
            array.includes(55) && //extraccion quirurgica
            array.includes(85) && //extraccion de restos radiculares sencilla 
            array.includes(86) //extraccion de restos radiculares quirurgica
          ) {
            //#EXTRACCIONES
            this.dataTreatmentsExtracciones = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
          } else if (array.includes(255)) {//aditamento de semiprecisión
          //#MINI IMPLANTES
            this.dataTreatmentsMiniImplantes = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
          } else if (array.includes(621)) {//tope de resina (pieza)
           //#TOPES DE RESINA
            this.dataTreatmentsTopesResina = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
          } else if (array.includes(410)) {//cirugia para traccion de caninos
          //#TRACCIÓN DE CANINOS
            this.dataTreatmentsTraccionCaninos = response.data.data.filter(
              function (item) {
                return item.nombre != "";
              }
            );
          }
          this.$forceUpdate();
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al obtener los tratamientos por id",
          });
          console.error(error);
        });
    },
    getTreatmentsSpeciality(array) {
      //condicional para tratamientos ORTODONCIA / ODONTOPEDIATRIA ||
      if (array.includes(3) && array.includes(4)) {
        const params = {
          idClinica: this.idClinica,
          lstIdsEspecialidad: array
        }
        this.$http
          .put(
            this.$api +
              "ptipresuntivo/obtener/catalogo/tratamientos/idespecialidadorigen",
              params
          )
          .then((response) => {
            this.dataTreatmentsOrtoOdonto = response.data.data.filter(function (
              item
            ) {
              return item.nombre != "";
            });
            this.$forceUpdate();
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al obtener los tratamientos por especialidad",
            });
            console.error(error);
          });
      } else if (array.includes(4)) {
        const params = {
          idClinica: this.idClinica,
          lstIdsEspecialidad: array
        }
        this.$http
          .put(
            this.$api +
              "ptipresuntivo/obtener/catalogo/tratamientos/idespecialidadorigen",
            params
          )
          .then((response) => {
            this.dataTreatmentsOrto = response.data.data.filter(function (
              item
            ) {
              return item.nombre != "";
            });
            this.$forceUpdate();
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al obtener los tratamientos por especialidad",
            });
            console.error(error);
          });
      }
    },
    getInfo() {
      const parametros = {idSolicitudEtapa: this.ptiId}
      this.$http
        .post(
          this.$api +
            "ptipresuntivo/obtener/datosGenerales", parametros
        )
        .then((response) => {
          let datos = response.data.data;

          this.DiagnosticData = {
            denticion: datos.denticion == 0 ? 3 : datos.denticion, // ! Si non trae denticion pone default adulto
            idClinica : datos.idClinica
          };
        })
        .catch((error) => {
          this.loading = false;
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "El PTI no es valido",
          });
          console.error(error);
        })
        .finally(() => {
          this.loading = false;

          this.idClinica = this.DiagnosticData.idClinica;
          this.getTreatmentsSpeciality([3, 4]); // ! ODONTOPEDIATRIA, ORTODONCIA
          this.getTreatmentsSpeciality([4]); // ! ORTODONCIA
          // ? POR ID
          // this.getTreatmentsIds([6, 120, 127, 618]); // ! RETENEDORES //#RET SUP  //#RET INF
          this.getTreatmentsIds([33, 1991, 1990, 1988, 1989, 35,294,629 ]); // ! RETENEDORES //#RET SUP  //#RET INF
          this.getTreatmentsIds([49]); // ! CITA DE AJUSTE
          // ? SEGUNDA SECCION
          this.getTreatmentsIds([9, 55, 85, 86]); // ! EXTRACCIONES
          this.getTreatmentsIds([255]); // ! MINI IMPLANTES
          this.getTreatmentsIds([621]); // ! TOPES DE RESINA
          this.getTreatmentsIds([410]); // ! TRACCIÓN DE CANINOS 
          this.$emit("_funcionCargandoOrtodoncia", false); 
          
        });
    },
    getDientes(tipo) {
      var url =
        tipo == "dientesAdulto"
          ? "ptipresuntivo/obtener/catalogo/dientes"
          : "ptipresuntivo/obtener/catalogo/dientes";

          const params = {
            adulto: tipo == "dientesAdulto" ? true : false, 
            ninio: tipo == "dientesAdulto" ? false : true,
          }
      this.$http
        .post(this.$api + url, params)
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            const finalData = JSON.parse(JSON.stringify(response.data.data));

            if (tipo == "dientesAdulto") {
              this.dientesAdultoArray = finalData.map(function (item) {
                var data = {
                  numeroDiente: item.numeroDiente,
                  idDiente: item.idDiente,
                };
                return data;
              });
            } else {
              this.dientesNinoArray = finalData.map(function (item) {
                var data = {
                  numeroDiente: item.numeroDiente,
                  idDiente: item.idDiente,
                };
                return data;
              });
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al obtener los dientes",
          });
          console.error(error);
        })
        .finally(() => {
          if (tipo == "dientesAdulto") {
            this.loadingDientesAdulto = false;
          } else {
            this.loadingDientesNino = false;
          }

          if (!this.loadingDientesAdulto && !this.loadingDientesNino) {
            this.getInfo();
          }
        });
    },
    
    sendData() {
      // ? BANDERA ORTODONCIA
      var banderaOrtodoncia = false;

      if (this.DiagnosticData.candidatoOrtodoncia == true) {
        var OrtodonciaCheckUno = false;
        var OrtodonciaCheckDos = false;
        var OrtodonciaCheckTres = false;

        var datos = {
          tratamientos1: this.ortodonciaAdulto["tratamientos1"].concat(
            this.ortodonciaAdultoDientes["tratamientos1"],
            this.ortodonciaNino["tratamientos1"],
            this.ortodonciaNinoDientes["tratamientos1"]
          ),
          tratamientos2: this.ortodonciaAdulto["tratamientos2"].concat(
            this.ortodonciaAdultoDientes["tratamientos2"],
            this.ortodonciaNino["tratamientos2"],
            this.ortodonciaNinoDientes["tratamientos2"]
          ),
          tratamientos3: this.ortodonciaAdulto["tratamientos3"].concat(
            this.ortodonciaAdultoDientes["tratamientos3"],
            this.ortodonciaNino["tratamientos3"],
            this.ortodonciaNinoDientes["tratamientos3"]
          ),
        };

        //BANDERA VALIDACION
        if (Array.isArray(datos.tratamientos1)) {
          datos.tratamientos1.forEach((item) => {
            if (
              item.idTratamiento != 49 &&
              item.idTratamiento != 0 &&
              (item.lstDientes == undefined ||
                item.lstDientes == null ||
                item.lstDientes.length == 0)
            ) {
              if (item.cantidad == 0 || item.idDienteArcoBoca == 0) {
                OrtodonciaCheckUno = true;
              }
            } else if (
              item.lstDientes != undefined &&
              item.lstDientes != null &&
              item.lstDientes.length != 0
            ) {
              if (item.idTratamiento == 0) {
                OrtodonciaCheckUno = true;
              }
            }
          });
        }

        if (Array.isArray(datos.tratamientos2)) {
          datos.tratamientos2.forEach((item) => {
            if (
              item.idTratamiento != 49 &&
              item.idTratamiento != 0 &&
              (item.lstDientes == undefined ||
                item.lstDientes == null ||
                item.lstDientes.length == 0)
            ) {
              if (item.cantidad == 0 || item.idDienteArcoBoca == 0) {
                OrtodonciaCheckDos = true;
              }
            } else if (
              item.lstDientes != undefined &&
              item.lstDientes != null &&
              item.lstDientes.length != 0
            ) {
              if (item.idTratamiento == 0) {
                OrtodonciaCheckDos = true;
              }
            }
          });
        }

        if (Array.isArray(datos.tratamientos3)) {
          datos.tratamientos3.forEach((item) => {
            if (
              item.idTratamiento != 49 &&
              item.idTratamiento != 0 &&
              (item.lstDientes == undefined ||
                item.lstDientes == null ||
                item.lstDientes.length == 0)
            ) {
              if (item.cantidad == 0 || item.idDienteArcoBoca == 0) {
                OrtodonciaCheckTres = true;
              }
            } else if (
              item.lstDientes != undefined &&
              item.lstDientes != null &&
              item.lstDientes.length != 0
            ) {
              if (item.idTratamiento == 0) {
                OrtodonciaCheckTres = true;
              }
            }
          });
        }

        if (
          OrtodonciaCheckUno == true ||
          OrtodonciaCheckDos == true ||
          OrtodonciaCheckTres == true
        ) {
          this.$swal.fire({
            icon: "info",
            title: "Faltan datos",
            text: "Falta llenar todos los campos en la sección de ortodoncia.",
          });
          banderaOrtodoncia = true;
        }
      }
      // ? BANDERA ORTODONCIA

      if (banderaOrtodoncia == false) {
        this.$swal.fire({
          title: "¿Estás seguro de guardar la información de ortodoncia? ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.banderaBtn = true;
            this.loading = true;

            var datos = {
              observaciones:
                this.observaciones == null
                  ? "Sin observaciones"
                  : this.observaciones,
              idEmpleado: this.$localStorageService.getIdEmpleado(),
              idPti: this.ptiId,
              tratamientos1: this.ortodonciaAdulto["tratamientos1"].concat(
                this.ortodonciaAdultoDientes["tratamientos1"],
                this.ortodonciaNino["tratamientos1"],
                this.ortodonciaNinoDientes["tratamientos1"]
              ),
              tratamientos2: this.ortodonciaAdulto["tratamientos2"].concat(
                this.ortodonciaAdultoDientes["tratamientos2"],
                this.ortodonciaNino["tratamientos2"],
                this.ortodonciaNinoDientes["tratamientos2"]
              ),
              tratamientos3: this.ortodonciaAdulto["tratamientos3"].concat(
                this.ortodonciaAdultoDientes["tratamientos3"],
                this.ortodonciaNino["tratamientos3"],
                this.ortodonciaNinoDientes["tratamientos3"]
              ),
            };

            datos.tratamientos1 = datos.tratamientos1.filter(
              (item) => item.cantidad != 0 && item.idTratamiento != null
            );

            datos.tratamientos2 = datos.tratamientos2.filter(
              (item) => item.cantidad != 0 && item.idTratamiento != null
            );

            datos.tratamientos3 = datos.tratamientos3.filter(
              (item) => item.cantidad != 0 && item.idTratamiento != null
            );

            if (Array.isArray(datos.tratamientos1)) {
              datos.tratamientos1.forEach((element) => {
                element.cantidad = parseInt(element.cantidad);
              });
            }

            if (Array.isArray(datos.tratamientos2)) {
              datos.tratamientos2.forEach((element) => {
                element.cantidad = parseInt(element.cantidad);
              });
            }

            if (Array.isArray(datos.tratamientos3)) {
              datos.tratamientos3.forEach((element) => {
                element.cantidad = parseInt(element.cantidad);
              });
            }
 

            
             
            
            this.$http
              .put(
                this.$api +
                  "ptipresuntivo/guardar/planes/ortodoncia?idUsuarioLogueado=" +
                  this.$localStorageService.getIdUsuario() +
                  "&idClinica=" +
                  this.$localStorageService.getIdClinica() +
                  "&idPaciente=" +
                  this.idPaciente + 
                  "&crearSolicitudBandeja=true"
                  ,
                datos
              )
              .then(() => {
                this.mostrarGuardarReplica = true;
                this.$emit("_funcionGuardado", true); 
                this.$swal({
                  icon: "success",
                  title: "Se ingresó correctamente",
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {},
                }); 
              })
              .catch((error) => { 
                this.mostrarGuardarReplica = false;
                this.$emit("_funcionGuardado", false);  
                
                this.banderaBtn = false;
                this.$swal.fire({
                  icon: "error",
                  title: "error",
                  text: error.response.data.message,
                });
              })
              .finally(() => {
                this.loading = false; 
              });
          },
        });
      }
    },
    
        
 
        
        
        
        
        
        
        
        
  },
  
  
};
</script>
